export default { PACKAGE_VERSION: "1.16.0" };
